module.exports = __webpack_public_path__ + "static/media/SOUNDoff.ad09f68e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SOUNDoff.png
// module id = 208
// module chunks = 0